import React from 'react';

class CV extends React.Component {
    render() {
        return (
            <main>
                <h1>This page is still incomplete. Check again later!</h1>
            </main>
        )
    }
}

export default CV;